import { render, staticRenderFns } from "./StaffDetail_Users.vue?vue&type=template&id=9c14a39c"
import script from "./StaffDetail_Users.vue?vue&type=script&lang=js"
export * from "./StaffDetail_Users.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports